<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='出科月度成绩' url='/achievement/stu/resultslist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.leavesec' label='科室' :dictid='this.$utils.DictEnum.section'></ZPGLSearchDictItemSelect>
          <SearchNormalText v-model='condition.stunno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考试时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.resultsdate" type="month" placeholder="考试时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">类别：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.resultstype" filterable placeholder="类别">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in resultstypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <ImportButton url="/achievement/stu/resultsimport" buttonname="导入"></ImportButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="SpecName" label="专业">
            </el-table-column>
            <el-table-column prop="SecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="考试时间" width="150">
              <template slot-scope="scope">
                {{scope.row.ResultsDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="ResultsScore" label="考试成绩">
            </el-table-column>
            <el-table-column prop="ResultsTypeName" label="类别">
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeaveList',
  data () {
    return {
      condition: {
        stuname: '',
        leavesec: '',
        stunno: '',
        stuspec: '',
        resultstype:'',
        token: '',
        pageSize: 10,
        currentPage: 1,
        recordCount: 0,
        firstSearch: true
      },
      resultstypeOptions:[{
        value: '1',
        label: '出科'
      }, {
        value: '2',
        label: '月度'
      }],
      tableData: null,
      searchUrl: this.$utils.Url.zpgl + '/api/APIStuResults/List',
      exportUrl: this.$utils.Url.zpgl + '/api/APIStuResults/ListOut',
      loading: true
    }
  },
  filters: {
    formatDate (val) {
      var now = new Date(val)
      var y = now.getFullYear()
      var m = now.getMonth() + 1
      var d = now.getDate()
      return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
      this.condition.firstSearch = false
      this.condition.currentPage = val
      this.$refs.btnSearch.Search()
    },
    // 分页操作
    handleSizeChange: function (val) {
      this.condition.firstSearch = false
      this.condition.pageSize = val
      this.condition.currentPage = 1
      this.$refs.btnSearch.Search()
    },
    Edit: function (row) {
      this.$router.push({name: 'LeaveEdit', params: {id: row.LeaveID}})
    },
    Delete: function (row) {
      var args = {
        id: row.LeaveID,
        token: this.condition.token
      }
      this.$utils.Delete(this.$utils.Url.zpgl + '/api/APILeave/Delete', args, row.StuName, this.$refs.btnSearch.Search)
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.$refs.btnSearch.Search()
  }
}
</script>

<style>
</style>
